module.exports = __webpack_public_path__ + "static/media/bb.3ed7b06f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bb.png
// module id = 1792
// module chunks = 0